module.exports = __webpack_public_path__ + "img/cumulative_bonus.fbff3c03.png";